import environment from "./base";

const authOauth = "https://api.delivapp.com/auth/";
const authAPI = "https://api.delivapp.com/auth/api/";
const backendAPI = "https://api.delivapp.com/rest/api/";
const analyticsAPI = "https://api.delivapp.com/analytics/api/";
const pusherAuthEndpoint = "https://api.delivapp.com/auth/api/pusher";
const qrserverAPI = "http://api.qrserver.com/v1/create-qr-code/";

const env = environment({
  authOauth,
  authAPI,
  backendAPI,
  analyticsAPI,
  pusherAuthEndpoint,
  qrserverAPI
});

export default {
  ...env,
  requestLocationTime: 10000,
  requestPendingCount: 30000,
  requestPendingOrdersTime: 30000,
  requestCustomerServiceOrders: 30000,
};
